import {IconButton} from '@wandb/components';
import React from 'react';

import {trackSetting} from '../../services/analytics/workspaceSettingsEvents';
import * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {useSectionSettingsContext} from '../WorkspaceDrawer/Settings/SectionSettingsContextProvider';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';
import {PinSectionButton} from './PinSectionButton';

export type SectionSettingsProps = {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  sectionComponentRef: React.RefObject<HTMLDivElement>;
};

export const SectionSettings = ({
  panelBankSectionConfigRef,
  sectionComponentRef,
}: SectionSettingsProps) => {
  const {contentType, toggleWorkspaceDrawer} = useWorkspaceDrawerContext();
  const {sectionRef: currentSectionRef} = useSectionSettingsContext();

  return (
    <div className="hidden gap-2 md:flex">
      <PinSectionButton panelBankSectionConfigRef={panelBankSectionConfigRef} />
      <IconButton
        tooltip={{
          children: 'Section settings',
          placement: 'bottom',
        }}
        icon="settings"
        variant="ghost"
        aria-label="Section settings"
        onPress={e => {
          toggleWorkspaceDrawer('section-settings', currentSectionRef);
          sectionComponentRef.current?.scrollIntoView({
            block: 'start',
            inline: 'start',
            behavior: 'smooth',
          });

          if (contentType == null) {
            trackSetting({
              action: 'open section drawer',
              page: 'workspace',
            });
          }
        }}
      />
    </div>
  );
};
